import { render } from "./PotentialScoringV2.vue?vue&type=template&id=6a6b28fc&scoped=true&lang=pug"
import script from "./PotentialScoringV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialScoringV2.vue?vue&type=script&setup=true&lang=js"

import "./PotentialScoringV2.vue?vue&type=style&index=0&id=6a6b28fc&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6b28fc"]])

export default __exports__